import styled, {css} from "styled-components"

import perkboxLogo from "@irati/ui/images/perkboxLogoWhite.svg"

export const Nav = styled.nav`
  ${({theme}) => css`
    background-color: ${theme.colors.primary2};
    padding: ${theme.spacing.three};
  `}
`

export const PerkboxLogo = styled.img.attrs(() => ({
  src: perkboxLogo,
  alt: "Perkbox logo"
}))`
  width: 100px;
`

export const Header = styled.div`
  ${({theme}) => css`
    background-color: ${theme.colors.tertiary.s2_50};
    padding: ${theme.spacing.three};
    margin-bottom: ${theme.spacing.four};
  `}
`
